import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Button } from 'primeng/button';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-show-more-dialog',
  templateUrl: './show-more-dialog.component.html',
  styleUrl: './show-more-dialog.component.scss'
})
export class ShowMoreDialogComponent {
  @ViewChild('closeBtn') closeBtn!: ElementRef;
  @ViewChild('ellipsisButton') ellipsisButton!: ElementRef;
  @Input() headerText = '';
  @Input() contentText = '';
  @Input() descriptionDirection: 'ltr' | 'rtl' | 'auto' = 'rtl';
  @Input() minLength = 100;
  @Input() currentLanguage!: Observable<string>;
  isVisible = false;


  showDialog() {
    this.isVisible = true;
  }
  hideDialog() {
    this.isVisible = false;
  }

  onDialogHide() {
    setTimeout(() => {
      this.ellipsisButton?.nativeElement?.focus();
    }, 0);
  }
  onDialogShow() {
    setTimeout(() => {
      this.closeBtn?.nativeElement?.focus();
    }, 0);
  }

}
